import { string } from 'prop-types'
import React from 'react'
import DatePicker from 'react-datepicker'
import alertIcon from './assets/alert.svg'

// Find more props and use cases at https://reactdatepicker.com/
const ReactDatePicker = ({ errorMessage, ...rest }) => (
  <div className={`datepicker-wrapper ${errorMessage && 'datepicker-wrapper--error'}`}>
    <DatePicker {...rest} dateFormat="dd/MM/yyyy" popperPlacement="auto-start" placeholderText="dd/mm/yyyy" />
    { errorMessage && <img src={alertIcon} alt="alert" className="alert" /> }
  </div>)

ReactDatePicker.propTypes = {
  errorMessage: string,
}

ReactDatePicker.defaultProps = {
  errorMessage: '',
}

export default ReactDatePicker
